export enum StartStatus {
  Loading = 'Loading',
  Questions = 'Questions',
  SetupDepreciation = 'SetupDepreciation',
  SetupFirm = 'SetupFirm',
}
